import React from "react";
import { Manager, Popper, Reference } from "react-popper";

type DropdownProps = {
  children: React.ReactNode;
  dropdownElement: React.ComponentType<Record<string, unknown>>;
  isOpen: boolean;
  offset: number;
};

const Dropdown = ({ children, dropdownElement, isOpen, offset }: DropdownProps) => {
  const Dropdown = dropdownElement;

  return (
    <Manager>
      <Reference>{({ ref }) => <div ref={ref}>{children}</div>}</Reference>
      <Popper placement="bottom-end" modifiers={[{ name: "offset", enabled: true, options: { offset: [0, offset] } }]}>
        {({ ref, style }) =>
          isOpen && (
            <div ref={ref} style={style} className="z-50">
              <Dropdown />
            </div>
          )
        }
      </Popper>
    </Manager>
  );
};

export default Dropdown;
